import * as React from 'react';
import { AlertActionsRoot, AlertCloseAction } from './AlertActions.style';
import Close from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

const AlertActions = ({ children, onClose, closeActionVisible }) => {
  if (!children && !closeActionVisible) {
    return null;
  }

  return (
    <AlertActionsRoot>
      {children ? (
        children
      ) : (
        <AlertCloseAction
          onClick={onClose}
          data-testid="close-icon"
          label="close"
          type="secondary"
          size="xSmall"
          icon={Close}
        />
      )}
    </AlertActionsRoot>
  );
};

AlertActions.propTypes = {
  // The custom alert actions
  children: PropTypes.node,

  // If the builtin close action is enable
  closeActionVisible: PropTypes.bool,

  // Callback for builtin close action
  onClose: PropTypes.func,
};

AlertActions.defaultProps = {
  children: null,
  closeActionVisible: false,
  onClose: () => {},
};

export default AlertActions;
